import { archiveGallery } from "./archive-design";
import { themeBlocks } from "./layout";

export function readerDevice(
  theme: any,
  mode: string,
  width: number,
): "desktop" | "mobile" {
  if (mode !== "archive" || !theme) return width <= 640 ? "mobile" : "desktop";
  const card = archiveGallery(theme, "desktop");
  const frame = themeBlocks(theme, "archiveCard", "desktop").find(
    (block) => block.id === "archiveCard-background",
  );
  const frameWidth =
    (card.cardWidth * (frame?.safeBox?.desktop.width ?? 100)) / 100;
  const reference = theme.artworkReferenceWidth || 1440;
  const breakpoint = Math.max(
    640,
    Math.round(reference * Math.min(1, Math.max(0.8, 280 / frameWidth))),
  );
  return width <= breakpoint ? "mobile" : "desktop";
}

let activeTransition: ViewTransition | undefined;
export async function dissolveLayout(commit: () => void, enabled: boolean) {
  if (
    !enabled ||
    !matchMedia("(hover:hover) and (prefers-reduced-motion:no-preference)")
      .matches
  ) {
    commit();
    return;
  }
  if (!document.startViewTransition) {
    commit();
    return;
  }
  if (!document.getElementById("pinedale-layout-dissolve")) {
    const style = document.createElement("style");
    style.id = "pinedale-layout-dissolve";
    style.textContent = `html.pinedale-layout-dissolve::view-transition-group(root){animation-duration:0s}html.pinedale-layout-dissolve::view-transition-old(root),html.pinedale-layout-dissolve::view-transition-new(root){animation-duration:180ms;animation-timing-function:ease-in-out}@media(prefers-reduced-motion:reduce){html.pinedale-layout-dissolve::view-transition-old(root),html.pinedale-layout-dissolve::view-transition-new(root){animation:none}}`;
    document.head.append(style);
  }
  activeTransition?.skipTransition();
  document.documentElement.classList.add("pinedale-layout-dissolve");
  const transition = document.startViewTransition(commit);
  activeTransition = transition;
  try {
    await transition.finished;
  } finally {
    if (activeTransition === transition) {
      activeTransition = undefined;
      document.documentElement.classList.remove("pinedale-layout-dissolve");
    }
  }
}
